import {
  Analytics,
  getAnalytics,
  logEvent as faLogEvent,
  setUserProperties as faSetUserProperties,
  setUserId,
} from 'firebase/analytics';
import { app } from '@/firebaseConfig';

let analytics: Analytics | undefined = undefined;
if (process.env.NODE_ENV === 'production') {
  analytics = getAnalytics(app);
}

export const sendAnalyticsEvent = (
  event: string,
  params?: Record<string, any>,
) => {
  if (!analytics) return;
  faLogEvent(analytics, event, params);
};

export const setAnalyticsUserProperties = (props: {
  userIds: { auth: string; firestore: string };
  email: string;
  tenantId: string;
}) => {
  const { userIds, email, tenantId } = props;
  if (!analytics) return;
  // Using auth ID as the "official" user ID here because it's easiest to access
  // in other places, and so is easiest to correlate with other debug logs.
  setUserId(analytics, userIds.auth);
  faSetUserProperties(analytics, {
    firestoreId: userIds.firestore,
    tenantId,
    email,
  });
};

export const clearAnalyticsUserProperties = () => {
  if (!analytics) return;
  setUserId(analytics, null);
  faSetUserProperties(analytics, {});
};
